<template>
    <div class="pageheader" style="margin-top: 5px;">
        <div class="page-bar" style="padding: 5px; border-radius: 4px;">
            <div class="row">
                <div class="col-md-12">
                    <router-link :to="{name: 'IndexPropostas'}" class="myIcon icon-success icon-ef-3 icon-ef-3b icon-color" style="float: left;">
                        <i class="fa fa-file fa-5x"></i>
                    </router-link>
                    <h3 class="text-success" style="padding-top: 20px!important;">Simulação de Crédito</h3>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        name: 'header-propostas'
    }
</script>



// WEBPACK FOOTER //
// src/views/propostas/_header.vue